import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { ILinkedObjectItem } from './linked-object-item.interface';
import { CommonModule } from '@angular/common';
import { AuLinkedObjectBtnModule } from '../au-linked-object-btn/au-linked-object-btn.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'au-linked-object-list',
	templateUrl: './au-linked-object-list.component.html',
	styleUrls: ['./au-linked-object-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, AuLinkedObjectBtnModule, MatTooltipModule],
})
export class AuLinkedObjectListComponent implements OnInit {
	@Input() items: ILinkedObjectItem[];
	@Input() maxItemsInRow: number;
	@Input() clickable = true;
	@Input() placeholder = '';
	@Input() key = '';

	@Output() openLinkPressed = new EventEmitter<any>();

	dataItems: ILinkedObjectItem[] = [];

	ngOnInit() {
		this.dataItems = this.getDataItems();
	}

	openLink(event: MouseEvent, linkObject: any): void {
		if (event) {
			event.stopPropagation();
		}
		if (this.clickable) {
			this.openLinkPressed.emit(linkObject);
		}
	}

	getDataItems(): ILinkedObjectItem[] {
		const dataItems = [];

		if (this.key && this.items) {
			this.items.forEach(item => {
				dataItems.push({
					...item,
					nameSelectedByKey: item[this.key],
				});
			});

			return dataItems;
		}

		return dataItems;
	}
}
